import React from 'react';
import NavbarUnder from './NavbarUnder';
import FormRegister from './FormRegister';
import FooterAtBottom from './FooterAtBottom';

import axios from 'axios';
import { graphql, gql } from 'react-apollo';

class App extends React.Component {
    constructor(props) {
        super(props);
        
    
    }

    render(){
        return (
            <div>
                <NavbarUnder />
                <FormRegister />
                <FooterAtBottom />
            </div>
        );
    }
}

const updateIP = gql`
    mutation updateIP($ip: String, $time: String){
        updateIP(ip: $ip, time: $time){
            _id
        }
    }
`
export default graphql(updateIP)(App);



// WEBPACK FOOTER //
// ./src/components/App/Index.js